import { Tab } from '@headlessui/react'
import { useDispatch, useSelector } from 'react-redux'
import { ListTabHelper } from '../../helpers/ListTabHelper'
import { SelectedTab, setCurrentTab } from '../../store/feautures/TabSlice'

export default function TabsComponent({categories, oriented = 'horizontal'}: any) {

  const currentTab = useSelector(SelectedTab);
  const dispatch = useDispatch();

  return (
      <div className="w-full py-2 sm:px-0">
        <Tab.Group
          selectedIndex={currentTab}
          onChange={(e: any) => dispatch(setCurrentTab({ selectedTab: e }))}
        >
          <div className={`${oriented === 'vertical' && 'flex gap-x-4'}`}>
            <Tab.List className={`flex ${oriented === 'vertical' ? 'flex-col gap-y-2 w-1/5' : 'flex-row'} `}>
              {Object.keys(categories).map((category) => (
                <Tab
                  key={`tab-btn-${category}`}
                  className={({ selected }) =>
                    `text-left outline-none transition-colors px-4 py-2 outline-none
                    ${selected
                      ? 'bg-green-100 text-green-700 font-medium border-[#064e3b] border-b-2 rounded-t-xl'
                      : 'text-gray-500 hover:bg-white/[0.12] hover:text-[#064e3b]'}`
                  }
                >
                  {ListTabHelper[category]}
                </Tab>
              ))}
            </Tab.List>
    
            {/* Contenuto dei tab */}
            <Tab.Panels className={`${oriented === 'vertical' ? 'w-4/5' : ''} mt-4 `}>
              {Object.values(categories).map((contentArr: any, idx: number) => (
                <Tab.Panel key={`${idx}-panel`}>
                  {contentArr?.map((content: any) => content?.component)}
                </Tab.Panel>
              ))}
            </Tab.Panels>
          </div>
        </Tab.Group>
      </div>
    );
}
